import { Injectable } from '@angular/core';
import {UserAccessPermissions} from "../entities/UserAccessPermissions";

@Injectable({
  providedIn: 'root'
})
export class AccessPermissionsService {
  constructor() { }
  UserAccessPermissions: UserAccessPermissions[] = []

  UpdateAccessPermissions(userAccessPermissions: UserAccessPermissions[] | undefined) {
    this.UserAccessPermissions = [];
    if (userAccessPermissions) {
        userAccessPermissions?.forEach((element) => {
        let copy = Object.assign({}, element);
        this.UserAccessPermissions.push(copy);
      });
    }
  }

  GetAccessPermissions() : UserAccessPermissions[]
  {
    return this.UserAccessPermissions;
  }
}
